<style lang="scss" scoped>
</style>

<template>
  <c-layout>
    <!-- title -->
    <template #title>
      <div>Manage Diodes</div>
    </template>

    <!-- tool bar -->
    <template #toolbar>
      <div class="control pr-3">
        <input v-model="query" class="input" type="text" placeholder="Filter results...">
      </div>
      <button class="button" @click="drawer='create'">Create</button>
    </template>

    <!-- right side bar -->
    <template #drawer>

      <!-- create -->
      <c-drawer v-show="drawer" @close="drawer=null">
        <create-diode-form v-show="drawer=='create'" @complete="drawer=null"/>
        <update-diode-form v-if="drawer=='update'" :diode="selected" @complete="drawer=null"/>
        <delete-diode-form v-if="drawer=='disable'" :serial="selected.serial" :complete="false"
                           @complete="drawer=null; selected=null;"/>
        <delete-diode-form v-if="drawer=='delete'" :serial="selected.serial" :complete="true"
                           @complete="drawer=null; selected=null;"/>
      </c-drawer>
    </template>

    <!-- main -->
    <template #content>

      <!-- diode table -->
      <c-sorted-table :values="filtered" v-if="Object.values(filtered).length" class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width: 300px"><c-sort-link name="email">User</c-sort-link></th>
            <th><c-sort-link name="serial">Serial</c-sort-link></th>
            <th><c-sort-link name="name">Name</c-sort-link></th>
            <th><c-sort-link name="location">Location</c-sort-link></th>
            <th><c-sort-link name="heartbeat">Last Event</c-sort-link></th>
            <th style="width: 225px;"></th>
          </tr>
        </thead>
        <template #body="sort">
          <tbody>
            <tr v-for="diode in sort.values" :key="diode.serial">
              <td>{{diode.email}}</td>
              <td>{{diode.serial}}</td>
              <td>{{diode.name | ifndef('-')}}</td>
              <td>{{diode.location | ifndef('-')}}</td>
              <td>{{diode.heartbeat | time | relative | ifndef('-')}}</td>
              <td>
                <router-link class="has-text-primary" :to="{name: 'diode', params: {serial: diode.serial}}">
                  view
                </router-link>
                <a href="#" class="has-text-primary pl-3" @click.prevent="update(diode)">edit</a>
                <a href="#" class="has-text-primary pl-3" @click.prevent="disable(diode)">
                  <span>disable</span>
                </a>
                <a v-if="user.is_superadmin" href="#" class="has-text-primary pl-3" @click.prevent="remove(diode)">
                  <span>delete</span>
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </c-sorted-table>

      <!-- no diodes banner -->
      <c-missing v-else>No diodes found.</c-missing>
    </template>

  </c-layout>
</template>

<script>
import { get } from 'vuex-pathify';
import matches from '@/utils/matches';
import api from '@/api';
import Diode from '@/models/diode';
import CreateDiodeForm from './create-diode-form';
import UpdateDiodeForm from './update-diode-form';
import DeleteDiodeForm from './delete-diode-form';


export default {
  name: 'manage-diodes',
  components: {
    CreateDiodeForm,
    DeleteDiodeForm,
    UpdateDiodeForm
  },
  data () {
    return {
      drawer: null,
      selected: null,
      query: ''
    };
  },
  created() {
    api.admin.diodes.load();
  },
  computed: {
    diodes: () => Diode.all().map(d => {return {...d, email: d.user ? d.user.email : '-'};}),
    filtered() {
      return this.diodes.filter(d => matches(d, ['name', 'location', 'serial', 'user.email'], this.query));
    },
    user: get('user')
  },
  methods: {
    update(diode) {
      this.drawer = 'update';
      this.selected = diode;
    },
    disable(serial) {
      this.drawer = 'disable';
      this.selected = serial;
    },
    remove(serial) {
      this.drawer = 'delete';
      this.selected = serial;
    }
  }
};
</script>
